Vue.component('ppcarto-filter',{
    template: `<div :class="['ppcarto-filter', section.key]" v-if="show">
                <a href="#" @click.prevent="close()" class="close">X</a>
                <h2>{{section.name}}</h2>
                <ul class="filter__categories">
                  <li class="filter__categories__item--all" v-bind:class="{active: selectAll}"><a href="#" v-on:click.prevent.stop="doSelectAll">Alle Kategorien</a></li>
                  <li class="filter__categories__item" v-bind:class="{ active: category.active }" v-for="category in section.categories"><a href="#" v-on:click.prevent="toggleSelectedCategory(category)">{{category.name}}</a></li>
                </ul>
               </div>`,
    data() {
        return {
            section: null,
            hidden: false
        }
    },
    computed: {
        activeSections(){
            return this.$store.getters.getHistory;
        },
        selectAll () {
            return this.section.categories.filter(c => !c.active) == 0
        },
        show() {
            return this.section != null && this.hidden == false;
        }
    },
    watch: {
        activeSections(nSections, oSections) {
            let s = _.last(nSections);            
            if(s && !s.action) {
                let as = _.find(this.$store.getters.allSections, x => x.key == s.key);
                if(as)
                    this.section = as;
                
                
                if(nSections.length == oSections.length) {
                    this.hidden = false;
                } 
            } else {
                this.section = null;
                this.hidden = true;
            }

            
        }
    },
    methods: {
        toggleSelectedCategory (category) {
            this.$store.commit('toggleSectionCategory', { section: this.section, category: category } )
            
        },
        doSelectAll () {
            this.section.categories.filter(c => !c.active).forEach(category => {
                this.$store.commit('toggleSectionCategory', { section: this.section, category: category } )
            })
        },
        close() {
            this.hidden = true;
        }
    }
})